var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'x12 m:x12 l:x11 xl:x10 m-x-a '+(_vm.padding?'':'m:')+'p-x-4'},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }